import React from 'react'
import Axios from 'axios'
import ResponseLoadingScreen from '../../ResponseLoadingScreen/ResponseLoadingScreen'
import './photo-upload.css'
import { baseUrl } from '../../assets/Animations'

const PhotoUpload = (props) => {
    const [imagePreview, setImagePreview] = React.useState('')
    const [loading, setLoading] = React.useState(false)

    const previewImage = (e) => {
        e.preventDefault()
        if(document.getElementById('the-teacher-image').files[0]) {
            const imageFile = document.getElementById('the-teacher-image').files[0]
            let path = URL.createObjectURL(imageFile)
            setImagePreview(path)
            if(imageFile.size > 1000000) {
                document.getElementById('size-limit').style.color = "red"
                document.getElementById('image-upload-button').style.backgroundColor = "#fff"
                document.getElementById('image-upload-button').style.border = "1px solid #555"
                document.getElementById('image-upload-button').style.color = "#555"
                document.getElementById('image-upload-button').style.cursor = "default"
            } else {
                document.getElementById('size-limit').style.color = "black"
                document.getElementById('image-upload-button').style.backgroundColor = "green"
                document.getElementById('image-upload-button').style.border = "1px solid #000"
                document.getElementById('image-upload-button').style.color = "#000"
                document.getElementById('image-upload-button').style.cursor = "pointer"
            }
        }
    }

    const clickTheX = () => {
        document.getElementById('photo-preview-circle').style.backgroundImage = "none"
        setImagePreview(null)
        props.toggleUploadModal()
    }


    const uploadThePhoto = (e) => {
        e.preventDefault()
        setLoading(true)
        const blob = document.getElementById('the-teacher-image').files[0]
        let uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1E9)
        let newFile = new File([blob], `${uniqueSuffix}.jpg`, {type: blob.type})
        let formData = new FormData()
        formData.append('teacherImage', newFile)
        if(newFile.size < 1000000) {
            Axios.post(`${baseUrl}/imageupload`, formData, {
                headers: {
                    'Authorization' : `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                if(response.status === 200) {
                    setTimeout(() => {
                        props.setImageName(`${uniqueSuffix}.jpg`)
                        setLoading(false)
                        props.toggleUploadModal()
                    }, 1000)
                    let path = URL.createObjectURL(newFile)
                    props.setImg(path)
                } else {
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false)
                alert(err)
            })
        } else {
            alert('Image too big!')
            setLoading(false)
        }
    }

    return(
        <>
        <ResponseLoadingScreen loading={loading} />
        {props.modal && 
            <div className="upload-modal-content" id="upload-modal-content">
                <div className="photo-upload-x" onClick={() => clickTheX()}>x</div>
                <ul className="image-specs-list">
                    {/* <li>File name is first and last name all lower case. Ex: steveharvey.jpg add something</li> */}
                    <li>Image is square with teacher's face close to the middle.</li>
                    <li id="size-limit">Must be smaller than 1MB (most are smaller than 100KB)</li>
                    <li>Image is a .jpg file</li>
                </ul>
                <div id="photo-preview-circle" style={{backgroundImage: `url(${imagePreview})`}} className="img-preview"></div>
                <form className='photo-upload__form' onChange={(e) => previewImage(e)} onSubmit={(e) => uploadThePhoto(e)}>
                    <input type="file" className="teacher-image-input" name="teacherImage" id="the-teacher-image"></input>
                    <input type="submit" id="image-upload-button" className="teacher-image-submit-btn" value="Upload" />
                </form>
            </div>
        }
        </>
    )
}

export default PhotoUpload